/**
 * The attribute every GestureSurface tags itself with, and the selector that finds it.
 *
 * Bare, with no game name in it: a page only ever shows one puzzle at a time, and it shows that
 * puzzle twice -- the mobile and desktop layouts both render, one of them hidden at zero size -- so
 * a name could not tell the two copies apart anyway. Whoever measures a grid picks between matches
 * by size, not by name (see useBackgroundBurstPosition).
 */
export const PUZZLE_GRID_ATTR = 'data-puzzle-grid';
export const PUZZLE_GRID_SELECTOR = `[${PUZZLE_GRID_ATTR}]`;
